import React from "react";
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import AddBoxIcon from "@material-ui/icons/AddBox";
import {
  alertsConfirmAction,
  projectModalOpenAction,
  userModalOpenAction,
} from "../features/sliceReducer/interactionReducer";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../features/store";
import {
  compareProjectAction,
  deleteCompareProjectAction,
} from "../features/sliceReducer/projectReducer";

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    caption: {
      padding: "24px 0 0 24px",
      fontWeight: "bold",
      fontSize: "18px",
    },
    tableContainer: {
      position: "relative",
      display: "flex",
      padding: "0px 24px 40px",
    },
    table: {
      "& .MuiTableCell-root": {
        padding: "12px",
      },
    },
  })
);

const CompareProject = () => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const {currentProject} = useSelector((state: RootState) => state.project);
  const {projectList} = useSelector((state: RootState) => state.projectList);

  // console.log(projectList);
  const compareProjects = projectList?.filter(
    (project) => currentProject?.compareProjectUIDs?.indexOf(project.uid) > -1
  );

  return (
    <React.Fragment>
      <Box>
        <Typography variant="subtitle1">
          <PersonAddIcon
            style={{marginRight: "8px", verticalAlign: "middle"}}
          />
          PSM 비교 프로젝트 추가
        </Typography>
        <Box className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>프로젝트 아이디</TableCell>
                <TableCell>프로젝트</TableCell>
                <TableCell align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxIcon />}
                    onClick={() => {
                      dispatch(projectModalOpenAction());
                      dispatch(compareProjectAction());
                    }}
                  >
                    프로젝트
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {compareProjects?.map((project, index) => (
                <TableRow key={project.uid}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{project.name}</TableCell>
                  <TableCell align="right">
                    <Button
                      onClick={() => {
                        dispatch(
                          alertsConfirmAction({
                            alertContent: "해당 프로젝트를 삭제하시겠습니까?",
                            alertAction: deleteCompareProjectAction(
                              project.uid
                            ),
                          })
                        );
                      }}
                    >
                      <IndeterminateCheckBoxIcon
                        style={{
                          color: "#f44336",
                          fontSize: "26px",
                        }}
                      />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default CompareProject;
